import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, Users, School, BookOpen, FileText, Newspaper, MessageSquare, BarChart3, Ticket, Package, ShieldCheck, Building2, Sparkles, AlertCircle, History, Layers, Award, Plug, Settings } from "lucide-react";

const links = [
  { to: "/admin", label: "Kontrol Paneli", icon: LayoutDashboard, end: true },
  { to: "/admin/kullanicilar", label: "Kullanıcılar", icon: Users },
  { to: "/admin/okullar", label: "Okullar", icon: School },
  { to: "/admin/okul-basvurulari", label: "Okul Başvuruları", icon: Building2 },
  { to: "/admin/okul-sahiplik", label: "Sahiplik Talepleri", icon: ShieldCheck },
  { to: "/admin/sorular", label: "Soru Bankası", icon: BookOpen },
  { to: "/admin/deneme-sinavlari", label: "Deneme Sınavları", icon: Ticket },
  { to: "/admin/cikmis-sorular", label: "Çıkmış Sorular", icon: History },
  { to: "/admin/abonelikler", label: "Modül & Abonelik", icon: Package },
  { to: "/admin/entegrasyonlar", label: "Entegrasyon Ayarları", icon: Plug },
  { to: "/admin/site-ayarlari", label: "Site Ayarları", icon: Settings },
  { to: "/admin/basvurular", label: "Tüm Başvurular", icon: FileText },
  { to: "/admin/yerlestirme-onay", label: "Yerleştirme Onayı", icon: Award },
  { to: "/admin/makaleler", label: "SEO Makaleleri", icon: Sparkles },
  { to: "/admin/blog", label: "Blog & SEO", icon: Newspaper },
  { to: "/admin/yorumlar", label: "Okul Yorumları", icon: MessageSquare },
  { to: "/admin/hatalar", label: "Frontend Hataları", icon: AlertCircle },
  { to: "/admin/kuponlar", label: "Kuponlar", icon: Ticket },
  { to: "/admin/iadeler", label: "İade Talepleri", icon: History },
  { to: "/admin/basvuru-fiyatlari", label: "Başvuru Fiyatları", icon: Layers },
  { to: "/admin/analitik", label: "Analitik", icon: BarChart3 },
];

export default function AdminLayout() {
  return <DashboardLayout links={links} title="Süper Admin" testIdPrefix="admin-sidebar" />;
}
